import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
  },
  {
    path: "/confrontation",
    name: "confrontation",
    component: () => import("@/views/ConfrontationView.vue"),
  },
  {
    path: "/coupe",
    name: "coupe",
    component: () => import("@/views/CoupeView.vue"),
  },
  {
    path: "/pays",
    name: "pays",
    component: () => import("@/views/PaysView.vue"),
  },
  {
    path: "/statistiques",
    name: "statistiques",
    component: () => import("@/views/StatistiquesView.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
